module.exports = __webpack_public_path__ + "static/better-guide-1080w-d64e8c4fc4dc39319a01e67e454b007c.jpg";